import React from 'react';
// Import the corresponding CSS file
import './ContactUs.css';
import DefaultData from '../../CompanyData/DefaultData';

const ContactUs = () => {
    // Data for office locations
    const officesData = [
        {
            name: 'Land Air Travels (India)',
            addressLines: [
                'GF-3, Tourism Plaza, 6-3-869/A,',
                'Greenlands, Begumpet,',
                'Hyderabad, Telangana 500016'
            ],
            icon: 'ri-map-pin-2-line'
        },
        {
            name: 'Land Air Travels LLC (USA)',
            addressLines: [
                '19232 Golden Meadows Drive,',
                'German Town, Maryland MD2087,',
                'U.S.A'
            ],
            icon: 'ri-building-4-line'
        },
        {
            name: 'Land Air Travels LLC (OHIO)',
            addressLines: [
                '12750 WESTCHESTER TRL NONE',
                'CHESTERLAND, OH 44026,',
                'U.S.A'
            ],
            icon: 'ri-community-line'
        },
        {
            name: 'Land Air Travels Private Limited (UK)',
            addressLines: [
                '209 Newbridge Road',
                'Bath BA1 3HH,',
                'U.K'
            ],
            icon: 'ri-home-4-line'
        },
        {
            name: 'Land Air Travels Private Limited (Wales)',
            addressLines: [
                '36 Doyle Avenue',
                'Cardiff CF5 3HT,',
                'Wales, U.K'
            ],
            icon: 'ri-road-map-line'
        }
    ];

    // Hero image for the contact page
    const heroStyle = {
        backgroundImage: `url('/assets/images/ContactUs.png')`,
    };

    return (
        <div className="main-content">
            <div className="contact-hero-section" style={heroStyle}>
                <div className="hero-overlay">
                    <div className="container text-center">
                        <h1 className="hero-heading">Contact Us</h1>
                        <p className="hero-subheading">We're here to help. Reach out to us anytime.</p>
                    </div>
                </div>
            </div>

            <div className="page-content">
                <div className="container">

                    {/* Top Contact Info Box */}
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="support-box text-center">
                                <i className="ri-customer-service-2-line support-icon"></i>
                                <h4>For Customer Support & Queries</h4>
                                <p>Get in touch with our dedicated support team.</p>
                                <a href={"mailto:" + DefaultData?.DEFAULTCOMPANYEMAIL} className="support-email">{DefaultData?.DEFAULTCOMPANYEMAIL}</a>
                            </div>
                        </div>
                    </div>

                    {/* Worldwide Offices Section */}
                    <div className="offices-section">
                        <h2 className="section-title">Worldwide Offices</h2>
                        <div className="row g-4">
                            {officesData.map((office, index) => (
                                <div className="col-lg-4 col-md-6" key={index}>
                                    <div className="office-card h-100">
                                        <div className="office-icon">
                                            <i className={office.icon}></i>
                                        </div>
                                        <h5 className="office-name">{office.name}</h5>
                                        <address className="office-address">
                                            {office.addressLines.map((line, i) => (
                                                <span key={i}>{line}<br /></span>
                                            ))}
                                        </address>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Google Map Section */}
                    <div className="map-section">
                        <h2 className="section-title">Our Hyderabad Location</h2>
                        <div className="map-container">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.5337612869043!2d78.45259667438938!3d17.434148701457925!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9a16ffffffff%3A0xe0ac70b267ec2468!2sLand%20Air%20Travels%20PVT.LTD.!5e0!3m2!1sen!2sin!4v1752482999064!5m2!1sen!2sin"
                                width="100%"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Location of Land Air Travels Hyderabad Office"
                            ></iframe>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ContactUs;